import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCGDz5c66QvU6hTWoeB1sWvjrmfFl_8OTI",
  authDomain: "greateasterntradingco.firebaseapp.com",
  databaseURL: "https://greateasterntradingco-default-rtdb.firebaseio.com",
  projectId: "greateasterntradingco",
  storageBucket: "greateasterntradingco.firebasestorage.app",
  messagingSenderId: "284830461951",
  appId: "1:284830461951:web:709084c655490832bd01ca"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

export { db };
